var _jsxFileName = "/repo/packages/webassets/src/components/Recaptcha/index.js",
  _this = this;
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, t } from '@sm/intl';
import { Box } from '@wds/box';
import { Toast } from '@wds/toast';
import useRecaptcha from './hooks/useRecaptcha.js';
import { StaticContext } from '../..';
import { WebAssetsThemeWrapper } from '../../theme';
var ERRORS = defineMessages({
  RECAPTCHA: {
    id: 'Recaptcha.ErrorWithRecaptcha',
    defaultMessage: 'Sorry, there was an error while getting the reCAPTCHA token.',
    description: '[Type: Button][Vis: High] - Error on getting reCAPTCHA token from Google'
  }
});
var Recaptcha = function Recaptcha(_ref) {
  var greToken = _ref.greToken,
    showError = _ref.showError,
    setShowError = _ref.setShowError,
    siteKey = _ref.siteKey,
    countryCode = _ref.countryCode;
  var _useContext = useContext(StaticContext),
    envCountryCode = _useContext.environment.countryCode,
    recaptchaV3 = _useContext.recaptchaV3;
  useEffect(function () {
    var script = document.createElement('script');
    var country = countryCode || envCountryCode;
    var url = country === 'CN' ? recaptchaV3.urlChina : recaptchaV3.url;
    script.src = "".concat(url, "?render=").concat(siteKey || recaptchaV3.siteKey);
    script.async = true;
    script.setAttribute('data-testid', 'Recaptcha_tag');
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [envCountryCode, recaptchaV3, countryCode, siteKey]);

  // wrapper with zIndex is required to make sure the recaptcha is on top of the footer
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      zIndex: 1000
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "gre_token",
    value: greToken,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Toast, {
    show: showError,
    autoClose: true,
    dismissible: true,
    onClose: function onClose() {
      return setShowError(false);
    },
    color: "warning",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Toast.Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 11
    }
  }, t(ERRORS.RECAPTCHA)))));
};
Recaptcha.propTypes = {
  greToken: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  setShowError: PropTypes.func.isRequired,
  siteKey: PropTypes.string,
  countryCode: PropTypes.string
};
Recaptcha.defaultProps = {
  siteKey: null,
  countryCode: null
};
export { Recaptcha, useRecaptcha };
//# sourceMappingURL=index.js.map